module.exports = __webpack_public_path__ + "img/zanorari10.c019afb4.jpg";